export default "__VITE_ASSET__gq5EHru5__"